import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/users`, {params: {...filter}})
  },


  create(user){
    return Http.post(`/users`, {user: {
      ...user,
      password: '#$&THRT2200',
      password_confirmation: '#$&THRT2200',
    }})
  },

  updateWithFormData(formData){
    return Http.put(`/users/${formData.get('user[id]')}`, formData);
  },

  update(user){
    return Http.put(`/users/${user.id}`, {
      user: {
        ...user,
      },
    });
  },

  show(id) {
    return Http.get(`/users/${id}`);
  },

  delete(id){
    return Http.delete(`/users/${id}`)
  }

}
